import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/rankingmasters.webp';
import screenshot_target from '../../../images/letterfunnel/sjorsgoemans.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Sjors Goemans"
      firstname="Sjors"
      companyname="Ranking Masters"
      competition="Seeders en Fingerspitz"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/sjorsgoemans.js